import React, { Dispatch, SetStateAction } from 'react'
import { Card, CardTitle, StackedSingleBarChart } from 'components'
import {
  ChartSection,
  CostText,
  MainAreaWrapper,
  StyledDivider,
} from './BlendSuggestions.styled'
import { BlendSelectableCard } from '../BlendSelectableCard/BlendSelectableCard'
import { useFormContext } from 'react-hook-form'
import { TBlend } from '../../../../../../types'
import { Attributes } from '../../../../Blends.styled'
import { BlendAttributeItem } from '../BlendAttributeItem/BlendAttributeItem'

export const BlendSuggestions = ({
  setFieldsChanged,
}: {
  setFieldsChanged: Dispatch<SetStateAction<boolean>>
}) => {
  const { watch, setValue } = useFormContext<TBlend>()
  const suggestions = watch('suggestions', [])

  const handleSelectSuggestion = (index: number) => {
    const selectedSuggestion = suggestions[index]

    if (!selectedSuggestion) return

    setValue('mixers', [])

    const newMixers = [
      {
        id: selectedSuggestion.id,
        name: selectedSuggestion.name,
        cost: selectedSuggestion.cost,
        selected: false,
        mixer_attributes: selectedSuggestion.suggestion_attributes,
        mixer_bins: selectedSuggestion.suggestion_bins.map((bin) => ({
          id: bin.id,
          bin_id: bin.bin_id,
          value: bin.value,
          bin_name: bin.bin_name,
          bin_color: bin.bin_color || '#000',
        })),
      },
    ]

    setValue(
      'suggestions',
      suggestions.map((suggestion, i) => ({
        ...suggestion,
        selected: i === index,
      }))
    )

    setValue('mixers', newMixers)
  }

  return (
    <Card p="16px">
      <CardTitle title="Blend Suggestions" />
      {suggestions.map((suggestion, index) => {
        const barChartData = suggestion.suggestion_bins
          .filter((bin) => bin.value > 0)
          .map((bin) => ({
            name: bin.bin_name,
            value: bin.value,
            color: bin.bin_color,
          }))

        return (
          <BlendSelectableCard
            key={index}
            selected={suggestion.selected}
            onClick={() => {
              handleSelectSuggestion(index)
              setFieldsChanged(true)
            }}
            footer={<CostText>Cost: {suggestion.cost} $/T</CostText>}
          >
            <MainAreaWrapper>
              <ChartSection>
                <StackedSingleBarChart data={barChartData} />
              </ChartSection>
              <StyledDivider orientation="vertical" />
              <Attributes>
                {suggestion.suggestion_attributes
                  .filter((attr) => attr.range_max > 0)
                  .map((attr, index) => {
                    return (
                      <BlendAttributeItem
                        key={attr.attribute_id || index}
                        attribute={attr}
                        labelWidth="106px"
                      />
                    )
                  })}
              </Attributes>
            </MainAreaWrapper>
          </BlendSelectableCard>
        )
      })}
    </Card>
  )
}
